import "@/App.css";
import "lenis/dist/lenis.css";
import { SmoothScroll } from "@/lib/smooth";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Nosotros } from "@/components/site/Nosotros";
import { Pillars } from "@/components/site/Pillars";
import { Pasteleria } from "@/components/site/Pasteleria";
import { Productos } from "@/components/site/Productos";
import { MenuCompleto } from "@/components/site/MenuCompleto";
import { Reuniones } from "@/components/site/Reuniones";
import { Galeria } from "@/components/site/Galeria";
import { Eco } from "@/components/site/Eco";
import { Sucursales } from "@/components/site/Sucursales";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFab } from "@/components/site/WhatsAppFab";
import { BackToTop } from "@/components/site/BackToTop";
import { Intro } from "@/components/site/Intro";
import { useCallback, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ContentProvider, STATIC } from "@/lib/content";
import Admin from "@/pages/Admin";

const seen = () => {
  try {
    return sessionStorage.getItem("amadeus-intro") === "1";
  } catch {
    return false;
  }
};

function Site() {
  const [intro, setIntro] = useState(() => !seen());
  const done = useCallback(() => {
    try {
      sessionStorage.setItem("amadeus-intro", "1");
    } catch {}
    setIntro(false);
  }, []);

  return (
    <div className="grain min-h-screen overflow-x-clip bg-espresso text-cream">
      <AnimatePresence>{intro && <Intro onDone={done} />}</AnimatePresence>
      {!intro && (
        <>
          <SmoothScroll />
          <Nav />
        </>
      )}
      <main>
        {intro ? <div className="h-screen" /> : <Hero />}
        <Marquee />
        <Nosotros />
        <Pillars />
        <MenuCompleto />
        <Pasteleria />
        <Galeria id="decorados" dataKey="DECORADOS" prefix="dec" cta={{ label: "btn_pas_wa", msg: "wa_msg_pas" }} />
        <Productos />
        <Reuniones />
        <Galeria />
        <Eco />
        <Sucursales />
      </main>
      <Footer />
      <WhatsAppFab />
      <BackToTop />
    </div>
  );
}

function App() {
  return (
    <ContentProvider>
      <BrowserRouter>
        <Routes>
          {!STATIC && <Route path="/admin" element={<Admin />} />}
          <Route path="*" element={<Site />} />
        </Routes>
      </BrowserRouter>
    </ContentProvider>
  );
}

export default App;
